import React, { useContext, useEffect, useState } from "react";
import { Colorcontext } from "../../../Component/Colorcontext/ColorContext";
import { useLocation } from "react-router-dom";
import ListBusinessPay from "../components/ListBusinessPay";

const ListBusinessPaymentPage = ({ formData, onBack }) => {
  const colordata = useContext(Colorcontext);
  const location = useLocation();
  const [data, setData] = useState(formData);

  useEffect(() => {
    colordata.setcolor(true);
    return () => {
      colordata.setcolor(false);
    };
  }, []);

  return (
    <>
      <section className="wizrd-item-section">
        <div className="wizrd-item-container">
          <div className="shoppingcontinue">
            <div className="shoppingcontinuebg">
              <div className="">
                <ListBusinessPay data={data} setData={setData} onBack={onBack} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ListBusinessPaymentPage;
